import { StyleSheet } from 'react-native';
import { PROFILE_COLORS, PROFILE_LAYOUT } from '../ProfileScreen/ProfileScreen.constants';

export const profileIdentityStyles = StyleSheet.create({
  nameBlock: {
    paddingHorizontal: 24,
    paddingTop: 4,
  },
  name: {
    fontSize: 26,
    fontWeight: '800',
    letterSpacing: -0.2,
    color: PROFILE_COLORS.text,
  },
  tierRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    marginTop: 2,
  },
  tierLabel: {
    fontSize: 13,
    fontWeight: '700',
    letterSpacing: 0.6,
  },
  tierDot: {
    color: PROFILE_COLORS.lockGrey,
    fontSize: 12,
  },
  levelText: {
    fontSize: 13,
    fontWeight: '600',
    color: PROFILE_COLORS.textMuted,
  },
  heroWrap: {
    alignSelf: 'center',
    marginTop: 6,
    marginBottom: 2,
    position: 'relative',
  },
  avatarPress: {
    borderRadius: 24,
  },
  avatarPressed: { opacity: 0.85, transform: [{ scale: 0.98 }] },
  avatarHover: { opacity: 0.92 },
  crest: {
    position: 'absolute',
    right: -18,
    bottom: -10,
    width: PROFILE_LAYOUT.crestSize,
    height: PROFILE_LAYOUT.crestSize,
  },
  xpBlock: {
    paddingHorizontal: 24,
    paddingTop: 16,
    gap: 6,
  },
  xpLabelRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'baseline',
  },
  xpLevelLabel: {
    fontSize: 12,
    fontWeight: '700',
    letterSpacing: 0.5,
    color: PROFILE_COLORS.purple,
  },
  xpToGo: {
    fontSize: 12,
    color: PROFILE_COLORS.textMuted,
  },
  xpToGoStrong: {
    color: PROFILE_COLORS.text,
    fontWeight: '700',
  },
  xpTrack: {
    height: 10,
    borderRadius: 9999,
    backgroundColor: PROFILE_COLORS.track,
    overflow: 'hidden',
  },
  xpFill: {
    height: '100%',
    borderRadius: 9999,
    backgroundColor: PROFILE_COLORS.purpleLight,
  },
});
